import videojs from "video.js";

export const isBrowserSupportedForVideoPlayback =
  videojs.browser.IS_CHROMIUM ||
  videojs.browser.IS_ANY_SAFARI ||
  videojs.browser.IS_EDGE ||
  videojs.browser.IS_FIREFOX ||
  videojs.browser.IS_IPHONE ||
  videojs.browser.IS_IPAD;
